import { NgModule } from '@angular/core';
import { CreatePasswordComponent } from './create-password.component';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { CreatePasswordRoutingModule } from './create-password-routing.module';
import { CreatePasswordFormComponent } from './create-password-form/create-password-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '@shared/shared.module';
import { ToastModule } from 'primeng/toast';

@NgModule({
  declarations: [CreatePasswordComponent, CreatePasswordFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FormsModule,
    SharedModule,
    ToastModule,
    CreatePasswordRoutingModule,
  ],
  providers: [TranslateService],
  exports: [],
})
export class CreatePasswordModule {}
